import { render } from 'preact';
import { GameShell } from '@app/GameShell';
import '@/style.css';

const root = document.getElementById('root');
if (root) {
	render(<GameShell />, root);
}
